/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TipoPraticaStato } from './tipo-pratica-stato';
import { TipologiaPratica } from './tipologia-pratica';


export interface TipoPraticaCittadinoSummaryDTO { 
    id?: string;
    codice?: string;
    titolo?: string;
    descrizione?: string;
    tipologia?: TipologiaPratica;
    stato?: TipoPraticaStato;
    data_apertura?: string;
    data_chiusura?: string;
    url_documentazione?: string;
    can_submit?: boolean;
}



